import { Text } from "@chakra-ui/react";
import { PropTypes } from "prop-types";

const QuizResultsTitle = ({ sortedFinalResults, resultCardLookup }) => {
  const suitableFinanceTypes = sortedFinalResults.reduce((acc, item) => {
    if (item.score > 0.75) {
      return [...acc, item];
    }
    return [...acc];
  }, []);

  localStorage.setItem(
    "suitableFinanceTypes",
    JSON.stringify(suitableFinanceTypes)
  );

  if (suitableFinanceTypes.length === 4) {
    return "All four finance types are suitable, check the details to find the best one for you.";
  }

  if (suitableFinanceTypes.length === 3) {
    return (
      <>
        <Text as="span" color="#FEE4A1">
          {resultCardLookup[suitableFinanceTypes[0].financeType].heading}
        </Text>
        {", "}
        <Text as="span" color="#FEE4A1">
          {resultCardLookup[suitableFinanceTypes[1].financeType].heading}
        </Text>{" "}
        and{" "}
        <Text as="span" color="#FEE4A1">
          {resultCardLookup[suitableFinanceTypes[2].financeType].heading}
        </Text>{" "}
        are the most suitable for your needs.
      </>
    );
  }

  if (suitableFinanceTypes.length === 2) {
    return (
      <>
        <Text as="span" color="#FEE4A1">
          {resultCardLookup[suitableFinanceTypes[0].financeType].heading}
        </Text>{" "}
        and{" "}
        <Text as="span" color="#FEE4A1">
          {resultCardLookup[suitableFinanceTypes[1].financeType].heading}
        </Text>{" "}
        are the most suitable for your needs.
      </>
    );
  }
  if (suitableFinanceTypes.length === 1) {
    return (
      <>
        <Text as="span" color="#FEE4A1">
          {resultCardLookup[suitableFinanceTypes[0].financeType].heading}
        </Text>{" "}
        is the most suitable for your needs.
      </>
    );
  }

  return <Text>No suitable results</Text>;
};

QuizResultsTitle.propTypes = {
  sortedFinalResults: PropTypes.array.isRequired,
  resultCardLookup: PropTypes.object.isRequired
};

export default QuizResultsTitle;
